import { useEffect, useState } from "react";

export default function BatteryGPS({ percent, charging }) {
  const [fillPercent, setFillPercent] = useState(0);

  const batteryWidth = 30;
  const batteryHeight = 15;

  useEffect(() => {
    // Animation du remplissage
    setFillPercent(percent);
  }, [percent]);

  const getColor = (p) => {
    if (charging) return "#2196f3"; // bleu si en charge
    if (p <= 20) return "#f44336"; // rouge
    if (p <= 50) return "#ff9800"; // orange
    return "#4caf50"; // vert
  };

  const fillWidth = (fillPercent / 100) * batteryWidth;

  return (
    <svg
      width={batteryWidth}
      height={batteryHeight}
      viewBox={`0 0 ${batteryWidth + 6} ${batteryHeight}`}
      style={{ display: "block" }}
    >
      {/* Contour batterie */}
      <rect
        x="0"
        y="0"
        width={batteryWidth}
        height={batteryHeight}
        fill="none"
        stroke="#333"
        strokeWidth="2"
        rx="3"
        ry="3"
      />

      {/* Remplissage animé */}
      <rect
        x="0"
        y="0"
        width={fillWidth}
        height={batteryHeight}
        fill={getColor(fillPercent)}
        style={{ transition: "width 0.5s ease, fill 0.5s ease" }}
      />

      {/* Petit bout batterie */}
      <rect
        x={batteryWidth}
        y={batteryHeight / 4}
        width="6"
        height={batteryHeight / 2}
        fill="#333"
        rx="1"
        ry="1"
      />

      {/* ⚡ si en charge */}
      {charging && (
        <polygon
          points={`${batteryWidth/2-3},2 ${batteryWidth/2+2},2 ${batteryWidth/2-1},8 ${batteryWidth/2+4},8`}
          fill="yellow"
        />
      )}

      {/* Texte pourcentage */}
      <text
        x={batteryWidth / 2}
        y={batteryHeight / 1.5}
        textAnchor="middle"
        fontSize="10"
        fill="#000"
      >
        {Math.round(fillPercent)}%
      </text>
    </svg>
  );
};